import { toast } from "react-toastify";

const handleToast = (type, message) => {
    toast[type](message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        theme: "dark",
      });
};

export default handleToast;